<template>
  <v-card class="item" height="100%" :to="to">
    <img
      width="100%"
      class="d-block item-img"
      :src="files + img + '?resize=1&w=300'"
      :alt="title"
    />

    <div class="d-flex flex-column justify-center px-md-3 pt-3 pb-3 pb-md-4">
      <div class="text-body-1 text-center item-title">
        {{ title }}
      </div>

      <div
        v-if="subtitle"
        class="grey--text text-body-2 text-center mt-1 item-text"
      >
        {{ subtitle }}
      </div>

      <div class="d-flex justify-center mt-1">
        <div class="text-center">
          <template v-if="price && variants.length">
            <div class="text-caption mb-n1">A partir de</div>
          </template>

          <div class="secondary--text text-h6 text-md-h5 font-weight-bold">
            {{ price ? formatPrice(price) : "Sob Consulta" }}
          </div>
        </div>
      </div>

      <v-btn
        class="text-caption text-sm-body-2 text-none font-weight-bold pa-0 mt-4"
        color="primary"
        height="auto"
        text
      >
        <v-icon class="mr-1 mb-1" :size="xsOnly ? '14px' : '18px'">
          fab fa-whatsapp
        </v-icon>
        Peça pelo Whatsapp
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import { formatPrice } from "../../utils/formatPrice";

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    price: {
      type: String,
      default: "",
    },
    variants: {
      type: Array,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    formatPrice,
    addToShoppingCart() {
      const id = this.id;
      const img = this.img;
      const title = this.title;
      const price = this.price;
      const observations = "";

      this.$shoppingCart.container.add({
        id,
        img,
        title,
        price,
        observations,
      });

      this.$toast.success(title + " foi adicionado ao carrinho.", {
        position: "top-right",
        timeout: 2000,
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
        draggable: false,
        draggablePercent: 0.1,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: false,
        icon: "fas fa-cart-plus",
        rtl: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border-radius: 4px !important;
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.05) !important;

  @media (max-width: 960px) {
    border-top: 1px solid #f1f1f1 !important;
    box-shadow: none !important;
  }

  @media screen and (max-width: 600px) {
    border-radius: 0 !important;
    grid-template-columns: auto calc(100% / 3);
  }

  &-img {
    aspect-ratio: 1;
    border-radius: 4px 4px 0 0 !important;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;

    @media screen and (max-width: 600px) {
      border-radius: 4px !important;
      order: 12;
    }
  }

  &-text {
    -webkit-box-orient: vertical;
    box-orient: vertical;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
